// extracted by mini-css-extract-plugin
export default {"header":"EditTeamMember_header__CAnYJ"};